import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} style={{position: 'initial', backgroundColor: 'mediumseagreen' }} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" style={{ color: '#fff',position: 'absolute'}} sx={{
          color: "text.secondary"
        }}>{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

export default function LinearWithValueLabel({progress}) {

  React.useEffect(() => {
  }, [progress]);

  return (
    <Box sx={{ width: '100%' }} >
      <LinearProgressWithLabel value={progress} style={{height: 50}}/>
    </Box>
  );
}